import { Popover, Spin } from 'antd';
import Text from 'components/Text';
import userApis from 'features/user/services/apis';
import { get } from 'lodash';
import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { IResponseDataBody } from 'services/response';
import styled from 'styled-components';
import { InfoBoxContent } from '../PopoverInfoBox';
import RectangleInfo from '../RectangleInfo';
import HomeDiscountPopoverContent from './PopoverContent';
import { IHomeReportDiscountResData } from 'features/user/services/types/discount';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { useAppDispatch } from 'store/hooks';
import reportActions from 'features/report/services/actions';
import { IHomeReportDiscountResItem } from 'features/report/services/types/discount';
import reportApis from 'features/report/services/apis';
import PrintReportDiscount from 'features/payment/pages/PrintPage/components/PrintReportDiscount';
import { useReactToPrint } from 'react-to-print';
import PermissionManager from 'widgets/PermissionVerify';

const HomeDiscountInfoBox = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IHomeReportDiscountResData | null>(null);
  const dispatch = useAppDispatch();
  const divRef = useRef<HTMLDivElement>(null);
  const setLoadingPage = useSetLoadingPage();
  const callbackResolve = useRef<() => void>(() => undefined);
  const doPrint = useReactToPrint({
    content: () => divRef.current,
    onAfterPrint: () => {
      callbackResolve.current?.();
    },
  });

  const handlePrintDiscount = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        doPrint();
      }, 100);
      callbackResolve.current = resolve as any;
    });
  };

  const validatePermission = async () => {
    const result = await PermissionManager.verify(PermissionManager.PERMISSIONS.REPORT_VIEW);
    if (result !== null) {
      if (!result || result?.skip) return true;
      if (!result.verifyData) return false;
      return true;
    }
    return false;
  };

  const onOpen = async () => {
    const isPermissionValid = await validatePermission();
    if (!isPermissionValid) return;
    setOpen(true);
    setLoading(true);
    try {
      const res: IResponseDataBody<IHomeReportDiscountResData> = await userApis.getHomeReportDiscount();
      if (res?.data?.data) {
        setData(res.data.data);
        dispatch(reportActions.getHomeReportDiscount.fetch());
      }
    } catch (error: any) {
      const msg = get(error, 'response.data.message');
      toast.error(msg || 'failed');
    } finally {
      setLoading(false);
    }
  };
  const handlePrint = async () => {
    setOpen(false);
    setLoadingPage(true);
    try {
      const res: IResponseDataBody<IHomeReportDiscountResItem[]> = await reportApis.getHomeReportDiscount();
      if (res.data.data) {
        dispatch(reportActions.getHomeReportDiscount.success(res.data.data));
        await handlePrintDiscount();
      }
    } catch (error) {
      dispatch(reportActions.getHomeReportDiscount.fail({}));
    } finally {
      setLoadingPage(false);
    }
  };

  return (
    <>
      <Popover
        content={<HomeDiscountPopoverContent onPrint={handlePrint} loading={loading} data={data} />}
        title={null}
        trigger='contextMenu'
        open={open}
        placement='topLeft'
        onOpenChange={setOpen}
        overlayClassName='custom-popover-no-padding'
      >
        <Button type='button' onClick={(e: any) => [e.stopPropagation(), e.preventDefault(), onOpen()]}>
          <InfoBoxContent $isActive={open}>
            <RectangleInfo isActive={open} isContact={false} isLastTicket={false} />
            <Text variant='CONTENT_2' className='text'>
              Discount
            </Text>
          </InfoBoxContent>
        </Button>
      </Popover>
      <div style={{ display: 'none' }}><PrintReportDiscount billRef={divRef} isPrinter /></div>
      {/* <div style={{ position: 'fixed', inset: 0, zIndex: 999999 }}><PrintReportDiscount billRef={divRef} isPrinter /></div> */}
    </>
  );
};

export default HomeDiscountInfoBox;

const Button = styled.button`
  border: none;
  background: none;
`;

const LoadingContent = () => {
  return (
    <LoadingContentStyled >
      <Spin />
    </LoadingContentStyled>
  );
};

const LoadingContentStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  width: 100px;
  height: 100px;
`;